import { useMutation, useQueryClient } from "@tanstack/react-query";
import axiosInstance from "../../../api";
import toastMessages from "../../helpers/toastMessage";
import { useOktaAuth } from "@okta/okta-react";

function useMarkUnfavoriteTest() {
  const authState = useOktaAuth()?.authState;
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["unFavoriteTest"],
    mutationFn: (data: { id: number }) =>
      axiosInstance.delete(`/v1/test-type/unfavorite-test/${data.id}`, {
        headers: {
          Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
        },
      }),
    onSuccess: () => {
      queryClient.refetchQueries({
        queryKey: ["favoriteTests"],
      });

      toastMessages.success('Test marked unfavorite')
    },
    onError: (error) => toastMessages.error(error.message),
  });
}
export default useMarkUnfavoriteTest;
